import apiInstance from "@services/Shared/instanceAxios";

const getProjects = () =>
  apiInstance({
    url: "/projects/",
  });

export default getProjects;
